import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaV3Provider } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyCykKrj2RJV8uVvoDUQQgkDzP_ngNa6KT4",
  authDomain: "italebtech-509cf.firebaseapp.com",
  projectId: "italebtech-509cf",
  storageBucket: "italebtech-509cf.appspot.com",
  messagingSenderId: "367503736366",
  appId: "1:367503736366:web:600373e3a4794939b4b727"
};

const app = initializeApp(firebaseConfig);

// 1. ✅ تصحيح خطأ 'self': استخدام 'window' بدلاً منه
if (typeof window !== "undefined") {
  if (window.location.hostname === "localhost") {
    window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  }
}

// 2. ✅ تصحيح خطأ المتغير غير المستخدم: إزالة 'const appCheck ='
// نحن نحتاج فقط لتشغيل الدالة (Initialization) ولا نحتاج للمتغير نفسه حالياً
try {
  initializeAppCheck(app, {
    provider: new ReCaptchaV3Provider('6Lcp3CQsAAAAALvsNTn7VjBtX_g3O3x6SVCJJHLu'),
    isTokenAutoRefreshEnabled: true
  });
} catch (error) {
  console.log("App Check init error (ignore on localhost if debug token used):", error);
}

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;